import type { Mission } from '../missions.ts'

export const eousa: Mission = {
  id: "eousa",
  name: "Executive Office for United States Attorneys",
  short: "U.S. Attorneys",
  call: "Attorneys",
  kind: "subagency",
  parent: "doj",
  url: "https://www.justice.gov/usao",
  established: 1953,
  palette: {
    primary: "#0f234b",
    secondary: "#0f234b",
    accent: "#fcb040",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Official_Logo_for_the_Executive_Office_for_United_States_Attorneys.png",
  },
  motif: "column",
  mission: {
    text: "The United States Attorneys serve as the nation's principal litigators under the direction of the Attorney General.",
    url: "https://www.justice.gov/usao/mission",
  },
  fact: {
    text: "EOUSA was created on April 6, 1953, by Attorney General Order No. 8-53 to provide close liaison between the Department of Justice in Washington, D.C., and the 93 United States Attorneys.",
    url: "https://www.justice.gov/usao/eousa/mission-and-functions",
  },
  seal: {
    file: "public/seals/eousa.png",
    source: "https://commons.wikimedia.org/wiki/File:Official_Logo_for_the_Executive_Office_for_United_States_Attorneys.png",
  },
  identifier: {
    about: "https://www.justice.gov/usao/eousa",
    accessibility: "https://www.justice.gov/accessibility/accessibility-statement",
    foia: "https://www.justice.gov/usao/resources/making-foia-request",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.justice.gov/doj/budget-and-performance",
    privacy: "https://www.justice.gov/doj/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/eousa-erie-courthouse.jpg",
        small: "/media/eousa-erie-courthouse-sm.jpg",
        alt: "The red brick and limestone Federal Building and U.S. Courthouse in Erie under a blue sky, with an American flag and a later wing to its right.",
        title: "Federal Building and U.S. Courthouse, Erie, Pennsylvania, June 11, 2015",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Federal_Building_and_U.S._Courthouse,_Erie,_Pennsylvania_LCCN2015646010.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/eousa-sacramento-courthouse.jpg",
        small: "/media/eousa-sacramento-courthouse-sm.jpg",
        alt: "The glass and stone federal courthouse in Sacramento, with an American flag and broad entry steps flanked by tall metal sculptures.",
        title: "Federal Courthouse, Sacramento, California",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Federal_Courthouse,_Sacramento,_California_LCCN2011634780.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
